import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

import { Publicacion } from '../models/publicacion';
import { PublicacionService } from '../services/publicacion.service';

import { Pelicula } from '../models/pelicula';
import { PeliculaService } from '../services/pelicula.service';

import { Espectaculo } from '../models/espectaculo';
import { EspectaculoService } from '../services/espectaculo.service';

import { Maraton } from '../models/maraton';
import { MaratonService } from '../services/maraton.service';

import { ProgramacionService } from '../services/programacion.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  noticias: Publicacion[];
  espectaculos: Espectaculo[];
  peliculas: Pelicula[];
  destacados: Publicacion[];

  portada;
  url = environment.imgUrl;


  constructor(
    private publicacionService: PublicacionService,
    private peliculaService: PeliculaService,
    private espectaculoService: EspectaculoService,
    private maratonService: MaratonService,
    private programacionService: ProgramacionService
  ) {


    this.portada = [
      {
        "id": null,
        "titulo": null,
        "subtitulo": null,
        "imagen": './public/cabecera/portada.jpg'
      },
      {
        "id": null,
        "titulo": null,
        "subtitulo": null,
        "imagen": './public/cabecera/portada.jpg'
      },
      {
        "id": null,
        "titulo": null,
        "subtitulo": null,
        "imagen": './assets/cabecera/portada.jpg'
      }
    ]
  }

  ngOnInit() {
    this.getEspectaculos();
    this.getNoticias();
    this.getPeliculas();
    this.getDestacados();
    this.getPortada();
  }

  getEspectaculos() {

    let filter = {

      "limit": 4
    }

    this.espectaculoService.getFilter(filter).subscribe(val => {
      this.espectaculos = val;
    });
  }

  getNoticias() {
    let filter = {

      "limit": 4
    }

    this.publicacionService.getFilter(filter).subscribe(val => {
      this.noticias = val;
    });
  }

  getPeliculas() {
    let filter = {
      "limit": 4
    }

    this.peliculaService.getFilter(filter).subscribe(val => {
      this.peliculas = val;
    });
  }

  getDestacados() {
    let filter = {
      "destacado": 1
    }

    this.publicacionService.getFilter(filter).subscribe(val => {
      this.destacados = val;

    });
  }

  getPortada() {
    let filter = {
      "destacado": 1
    }

    // this.peliculaService.getFilter(filter).subscribe(val => {
    //   this.portada[0] = {
    //     "id": val[0].id,
    //     "titulo": val[0].titulo,
    //     "subtitulo": val[0].subtitulo,
    //     "imagen": val[0].imagen_horizontal
    //   }
    //
    // });

    // this.programacionService.getFilter(filter).subscribe(val => {
    //   this.portada[0] = {
    //     "id": val[0].destacada.id,
    //     "titulo": val[0].destacada.titulo,
    //     "subtitulo": val[0].destacada.subtitulo,
    //     "imagen": val[0].destacada.imagen_horizontal
    //   }
    //
    // });

    this.peliculaService.getFilter(filter).subscribe(val => {
      this.portada[0] = {
        "id": val[0].id,
        "titulo": val[0].titulo,
        "subtitulo": val[0].subtitulo,
        "imagen": val[0].imagen_horizontal
      }

    });

    this.espectaculoService.getFilter(filter).subscribe(val => {
      this.portada[1] = {
        "id": val[0].id,
        "titulo": val[0].titulo,
        "subtitulo": val[0].subtitulo,
        "imagen": val[0].imagen_horizontal
      }
    });

    this.maratonService.getFilter(filter).subscribe(val => {
      this.portada[2] = {
        "id": val[0].id,
        "titulo": val[0].titulo,
        "subtitulo": val[0].subtitulo,
        "imagen": './assets/cabecera/maraton.jpg'
      }
    });
  }
}
